import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/getting-started/GettingStartedClient.tsx");
